import React, { forwardRef, useContext } from 'react';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import MenuItem from '@material-ui/core/MenuItem';
import TableChartIcon from '@material-ui/icons/TableChart';
import { BulkOperationsContext } from '@modules/planner/calendar/controls/bulk-operations/bulk-operations-context';
import { PlannerContext } from '@modules/planner/planner-context';
import {
  getSelectedBusinessWorkOrderIds,
  getSelectedInternalWorkOrderIds,
} from '@modules/planner/work-order-id-utils';
import { WorkOrder } from '@models';

type MenuItemProps = {
  closeMenu: () => void;
  workOrder?: WorkOrder;
  afterSubmit?: () => void;
};

export const WorkOrderBulkOperationsMenuItems = forwardRef<
  HTMLLIElement,
  MenuItemProps
>(function LockWorkOrderMenuItem({ closeMenu }, ref) {
  //const { testPrompt } = useContext(PromptContext);
  //const handleLock = useHandleLockWorkOrder(workOrder, afterSubmit, closeMenu);
  const { showSelectedWorkOrdersInTable } = useContext(PlannerContext);
  const { selected } = useContext(BulkOperationsContext);

  return (
    <MenuItem
      ref={ref}
      onClick={() => {
        const workOrderIds = getSelectedBusinessWorkOrderIds(selected);
        const ids = getSelectedInternalWorkOrderIds(selected);

        if (workOrderIds.length === 0 || ids.length === 0) {
          closeMenu?.();
          return;
        }

        showSelectedWorkOrdersInTable({
          ids,
          workOrderIds,
        });
        closeMenu?.();
      }}
    >
      <ListItemIcon>
        <TableChartIcon fontSize="small" />
      </ListItemIcon>
      Zobraz označené v zozname PP
    </MenuItem>
  );
});
